export default "__VITE_ASSET__bd32571b__"